
import { defineComponent, reactive, toRefs, onMounted, ref } from "vue";
import { httpChannelSelectList } from "@/api/DistributionManagement/ChannelManagement";
import { merchantgetAll } from "@/api/Merchantapi";
import { httpMerchantAdd, httpMerchantList, httpMerchantUpdateRecord } from "@/api/DistributionManagement/DistributionMerchantManagement";
import type { FormInstance, FormRules } from "element-plus";
import { ElMessage, ElMessageBox } from "element-plus";
import fTime from "@/utils/fTime"; //时间转换
export default defineComponent({
  name: "examine",
  setup() {
    let data = reactive<any>({
      // 头部查询
      formList: [
        {
          label: "分销渠道",
          type: "select",
          placeholder: "请选择分销渠道",
          key: "channelId",
          name: "valueName",
          clearable: true,
          optionList: [],
        },
      ],
      // 分销渠道列表下拉框请求
      getSelection: () => {
        httpChannelSelectList().then((res) => {
          if (res.code == 1) {
            data.formList[0].optionList = res.data.map((v: any) => {
              return { label: v.channelName, value: v.id };
            });
          }
        });
      },
      // 查询
      submitForm: (val: any) => {
        data.MyTable.selectData.channelId = val.value.channelId;
        data.getTableData();
        ElMessage({
          type: "success",
          message: "查询成功！",
        });
      },
      //弹框标题
      dialogTit: "创建分销商户",
      // 商户下拉
      merchantList: [],
      // 分销商户下拉
      merchantSelect: () => {
        merchantgetAll({ isFilter: true }).then((res: any) => {
          if (res.code == 1) {
            data.merchantList = res.data.map((v: any) => {
              return { label: v.merchantName, value: v.id };
            });
          }
        });
      },
      // 添加信息
      addForm: {
        channelId: "",
        merchantId: "",
        channelCommission: "",
        fxCommission: "",
        takeEffectTime: "",
      },
      // 添加渠道开关
      addChannel: false,
      // 禁止编辑
      addDisabled: false,
      addTimeDisabled: false,
      //添加渠道点击事件
      addDialog: (msg?: any) => {
        //判断对象是否为空,是否是编辑
        if (msg) {
          console.log("编辑的对象：", msg);
          fTime(msg.takeEffectTime) > new Date().getTime() ? (data.addTimeDisabled = false) : (data.addTimeDisabled = true);
          data.dialogTit = "编辑分销商户";
          data.addForm = { ...msg };
          data.addForm.takeEffectTime = fTime(msg.takeEffectTime);
          console.log(data.addForm);

          data.addDisabled = true;
        } else {
          data.addDisabled = false;
          data.addTimeDisabled = false;
          data.dialogTit = "创建分销商户";
          data.addForm = reactive({
            channelId: "",
            merchantId: "",
            channelCommission: "",
            fxCommission: "",
            takeEffectTime: "",
          });
        }
        data.addChannel = true;
      },
      addFormRef: ref<FormInstance>(),

      rules: reactive<FormRules>({
        //表单验证规则
        channelId: [{ required: true, message: "请选择渠道", trigger: "blur" }],
        merchantId: [{ required: true, message: "请选择商户", trigger: "blur" }],
        channelCommission: [{ required: true, message: "请输入金额", trigger: "blur" }],
        fxCommission: [{ required: true, message: "请输入金额", trigger: "blur" }],
        takeEffectTime: [{ required: true, message: "请选择时间", trigger: "blur" }],
      }),
      // 禁止选择今天和之前的时间
      disabledDate: (time: Date) => {
        return time.getTime() < Date.now();
      },
      // 确认添加和修改
      addSubmit: async (formEl: FormInstance | undefined) => {
        if (!formEl) return;
        await formEl.validate((valid: any, fields: any) => {
          if (valid) {
            //如果表单验证成功，就获取表单数据
            ElMessageBox.confirm("是否确认" + data.dialogTit, {
              confirmButtonText: "确认",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                httpMerchantAdd(data.addForm).then((res) => {
                  if (res.code) {
                    data.addChannel = false;
                    ElMessage({
                      type: "success",
                      message: "操作成功！",
                    });
                    data.getTableData();
                  }
                });
              })
              .catch(() => {});
          }
        });
      },
      //MyTable组件相关数据
      MyTable: {
        tableloading: false,
        //表格数据
        tableData: [
          // adminId: 添加人id,
          // cardNum: 开卡客户数量,
          // channelCommission: 渠道每单分佣,
          // channelId: 渠道id,
          // channelName: 渠道名称,
          // createTime: 添加时间,
          // fxCommission: 繁星每单分佣,
          // id: id,
          // merchantId: 商户id,
          // merchantName: 商户名称,
          // status: 00:未生效 01:已生效,
          // takeEffectTime: 生效时间,
          // updateTime: 更新时间,
        ],
        //请求参数
        selectData: {
          channelId: "",
          pageNum: 1,
          pageSize: 10,
        },
        // 表头数据
        tableColumn: [
          {
            prop: "channelName",
            label: "分销渠道",
          },
          {
            prop: "merchantName",
            label: "连锁商户",
          },
          {
            prop: "channelCommission",
            label: "渠道每单分佣",
          },
          {
            prop: "fxCommission",
            label: "繁星每单分佣",
          },
          {
            prop: "createTime",
            label: "创建时间",
          },
          {
            prop: "takeEffectTime",
            label: "生效时间",
          },
          {
            slotName: "slotName",
          },
        ],
        //表格数据
        TotalPageTable: 0,
      },
      // 向后台请求表格数据
      getTableData: () => {
        data.MyTable.tableloading = true;
        httpMerchantList(data.MyTable.selectData).then((res) => {
          if (res.code) {
            data.MyTable.tableData = res.data.list.map((v: any) => {
              v.createTime = fTime(v.createTime);
              v.takeEffectTime = fTime(v.takeEffectTime);
              v.updateTime = fTime(v.updateTime);
              return v;
            });
            data.MyTable.TotalPageTable = res.data.total;
            data.MyTable.tableloading = false;
          }
        });
      },
      // 表格翻页
      handleMyTable: (val: any) => {
        data.MyTable.selectData.pageNum = val;
        data.getTableData();
      },
      // 查看修改记录
      seeTable: {
        tableloading: false,
        tableData: [
          // "adminName": 操作人,
          // "content": 修改内容,
          // "createTime": 操作时间,
          // "id": 0
        ], //表格数据
        selectData: {
          pageNum: 1, //当前页码
          pageSize: 10, //当前页显示条数
        },
        // 表头数据
        tableColumn: [
          {
            prop: "adminName",
            label: "操作人",
          },
          {
            prop: "createTime",
            label: "操作时间",
          },
          {
            prop: "content",
            label: "操作内容",
          },
        ],
        // 查看分销商户分页
        seeHandleCurrentChange: (val: any) => {
          data.seeTable.selectData.pageNum = val;
          data.seeDialog();
        },
        // 查看分销商户开关
        seeChannel: false,
        TotalPageTable: 0,
      },
      // 查看修改记录
      seeDialog: (msg: any) => {
        console.log("查看的对象：", msg);
        data.seeTable.tableloading = true;
        httpMerchantUpdateRecord({ ...data.seeTable.selectData, id: msg.id }).then((res) => {
          if (res.code) {
            data.seeTable.tableData = res.data.list.map((v: any) => {
              v.createTime = fTime(v.createTime);
              return v;
            });
            data.seeTable.TotalPageTable = res.data.total;
            data.seeTable.tableloading = false;
          }
        });
        data.seeTable.seeChannel = true;
      },
    });
    onMounted(() => {
      data.getTableData();
      data.getSelection();
      data.merchantSelect();
    });

    return {
      ...toRefs(data),
    };
  },
});
